export const MAX_PROFILES = 10;
